import { SvgIcon, SvgIconProps } from '@mui/material';

const MenuOpen = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_7890_23983"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="-1"
      y="0"
      width="25"
      height="24"
    >
      <rect width="24" height="24" transform="matrix(-1 0 0 1 23.9999 0)" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_7890_23983)">
      <path
        d="M20.4998 17.5V16H8.28825V17.5H20.4998ZM4.55351 16.548L9.12101 12L4.55351 7.4615L3.49976 8.5155L7.01326 12L3.49976 15.4943L4.55351 16.548ZM20.4998 12.75V11.25H11.2113V12.75H20.4998ZM20.4998 8V6.5H8.28825V8H20.4998Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
);
export default MenuOpen;
